export default __webpack_public_path__ + "static/media/jangwon_nft_10.94323d82.svg";